// import { createPinia } from 'pinia'

// const store = createPinia()
// export default store

import { useMenuStore } from './menu'
import { useLanguageStore } from './language'
import { useTaskPositionStore } from './taskPosition'
import { useUserStore } from './user'
import { useShowTaskStore } from './controlTaskShow'

const appStore = {}

export const registerStore = () => {
  appStore.useMenu = useMenuStore()
  appStore.useLanguage = useLanguageStore()
  appStore.useTaskPosition = useTaskPositionStore()
  appStore.useUser = useUserStore()
  appStore.useTaskShow = useShowTaskStore()
}
export default appStore
